import { EventHandler } from '../event-handler'

export class EventNameAppender extends EventHandler {
  /**
   * @param {import('./event-name-page-mapper').EventNamePageMapper} eventNamePageMapper
   * @param {import('./event-name-builder').EventNameBuilder} eventNameBuilder
   */
  constructor(eventNamePageMapper, eventNameBuilder) {
    super()

    this._eventNamePageMapper = eventNamePageMapper
    this._eventNameBuilder = eventNameBuilder
  }

  /**
   * @param {import('../event').Event} event
   */
  handle(event) {
    const { eventComponentName, ...payload } = event.getPayload()
    const eventPage = this._eventNamePageMapper.getCurrentPage()
    const eventName = this._eventNameBuilder
      .withPageName(eventPage)
      .withComponentName(eventComponentName)
      .withAction(event.getType())
      .build()

    event.setPayload({ ...payload, eventName })

    super.handle(event)
  }
}
